import axios from "axios";
import React, { useState, useContext } from "react";
import { Box, Paper } from "@mui/material";

export default function EsqueciSenha() {
  const [emailPerdido, setEmailPerdido] = useState("");
  const [msg, setMsg] = useState("");

  const handleSubmit = async () => {
    try {
      const res = await axios.post("https://whats.nafil.com.br/api/Acessos/forgot-password", { emailPerdido });
      setMsg("Verifique seu e-mail para redefinir a senha.");
    } catch {
      setMsg("E-mail não encontrado.");
    }
  };
  return (
    <div>
      <Box minHeight={'150px'}>
        <Paper elevation={1} style={{ backgroundColor: '#f5f5dc', height: "100%", marginTop: "10px" }}>
          <h2>Esqueci minha senha</h2>
          <input
            type="email"
            placeholder="Digite seu e-mail"
            value={emailPerdido}
            onChange={(e) => setEmailPerdido(e.target.value)}
          />
          <button onClick={handleSubmit}>Enviar</button>
          <p>{msg}</p>
        </Paper>
      </Box>
    </div>
  );
}
